import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import HoverListDescription from '@/components/list/HoverListDescription';
import formFieldTypes from '../constants';
import { typedValue } from '../helper';

const FormItemDescription = ({
  canEdit,
  field,
  showEdit,
  text,
  toolTip = 'top right',
}) => {
  const intl = useIntl();
  return (
    <HoverListDescription
      canEdit={canEdit}
      className={clsx('aridhia-form-item-description', `form-description-${field.type}`)}
      editCopyMods="field-container"
      markdown={field.type === formFieldTypes.MD.type}
      position="top"
      showEdit={showEdit}
      toolTip={toolTip}
      value={typedValue(text, intl, field)}
    />
  );
};

export default FormItemDescription;
